export default __webpack_public_path__ + "static/media/Fuchs.c99c00ef.webp";